export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function idxOf(arr, item, key) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] === item[key]) {
      return i
    }
  }
  return -1
}

export function deleteRepeat(arr) {
  const newArr = []
  for (let i = 0; i < arr.length; i++) {
    if (idxOf(newArr, arr[i], 'id') === -1) {
      newArr.push(deepCopy(arr[i]))
    }
  }
  return newArr
}
